import { render, staticRenderFns } from "./MaximumBenefitLimit.vue?vue&type=template&id=1dafd387&scoped=true"
import script from "./MaximumBenefitLimit.vue?vue&type=script&lang=js"
export * from "./MaximumBenefitLimit.vue?vue&type=script&lang=js"
import style0 from "./MaximumBenefitLimit.vue?vue&type=style&index=0&id=1dafd387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dafd387",
  null
  
)

export default component.exports